import { useEffect, useState } from "react";
import UsuariosService from "../api/usuarios.api";

/**
 * Hook para resolver el catálogo de roles que necesita el select de
 * UsuarioForm (alta/edición de usuario).
 *
 * DECISION: se carga una única vez por montaje (useEffect con deps vacías),
 * sin caché entre aperturas del modal. Los roles del sistema (admin,
 * reponedor, almacen, sat, marketing) son un catálogo prácticamente
 * inmutable y GET /usuarios/roles no tiene permiso RBAC propio: una petición
 * ligera por apertura de modal no compensa la complejidad de una caché
 * (módulo, contexto o similar) para un beneficio despreciable. Si
 * ModalUsuario (TASK-009) desmonta su contenido al cerrarse, cada apertura
 * vuelve a pedirlos; mientras el componente sigue montado, no se repite la
 * llamada aunque se produzcan renders.
 *
 * El fallo de esta carga NO bloquea el formulario: username, email y
 * password siguen editables aunque roles quede vacío, porque
 * POST/PUT /usuarios acepta roleId como opcional (ver usuarios.api.js).
 *
 * @returns {{ roles: Array, loadingRoles: boolean, errorRoles: string|null }} Catálogo de roles y su estado de carga
 */
export const useUsuarioFormData = () => {
    const [roles, setRoles] = useState([]);
    const [loadingRoles, setLoadingRoles] = useState(true);
    const [errorRoles, setErrorRoles] = useState(null);

    useEffect(() => {
        let cancelado = false;

        (async () => {
            setLoadingRoles(true);
            setErrorRoles(null);
            try {
                const listaRoles = await UsuariosService.getRoles();
                if (cancelado) return;

                setRoles(listaRoles);
            } catch (err) {
                if (!cancelado) {
                    setErrorRoles(err.message || "No se pudieron cargar los roles disponibles.");
                }
            } finally {
                if (!cancelado) setLoadingRoles(false);
            }
        })();

        return () => { cancelado = true; };
    }, []);

    return { roles, loadingRoles, errorRoles };
};
